import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AlertService, ReportsService } from 'src/app/shared';

@Component({
  selector: 'app-cand-res-log',
  templateUrl: './cand-res-log.component.html',
  styleUrls: ['./cand-res-log.component.scss']
})
export class CandResLogComponent implements OnInit , OnDestroy{

  sub:any;
  

  center:any;
  batch:any;
  candidate:any;
  model:any;

  filter: any = {
    key: ""
  };
  pageSize = 25;
  currentPage = 1;
  total = 0;
  format  = "DD-MM-YYYY hh:mm:ss a";

  sections:any = [];
  answers:any = [];

  constructor(
    private activateRoute: ActivatedRoute,
    private alert:AlertService, 
    private router: Router,
    private reportService: ReportsService
    ) { }

  ngOnInit() {
    this.sub  = this.activateRoute.paramMap.subscribe (res=>{

      this.center = res.get ("center");
      this.batch = res.get ("batch");
      this.candidate = res.get ("candidate"); 
      this.getReport (); 
    });

  }

  getReport (){

    //var p = this.path + "/candidate/" + data.center + "/" + data.batch + "/" + data.candidate;
    var data = {
      center: this.center, 
      batch: this.batch, 
      candidate: this.candidate
    };

    this.reportService.getCandidateLogs (data, this.filter, this.pageSize, this.currentPage)
    .pipe (first())
    .subscribe ((res:any) =>{
      this.model = res.data;
      this.total = res.count;
      

    });
  }

  onPageChanged (e){
    this.currentPage = e;
    this.getReport();
  }


  ngOnDestroy (){
    if (this.sub){
      this.sub.unsubscribe ();
    }
  }

}
